import * as React from 'react';
import { type FC } from 'react';
import {
  Button,
  Link,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Paper,
  CircularProgress,
} from '@mui/material';
import {
  LogoutRounded,
  HelpOutline,
  SettingsRounded,
  TuneRounded,
  SummarizeRounded,
} from '@mui/icons-material';

import { type IHeaderProfileMenuItem } from '../../model/types';

import styles from './styles';

interface IProfileMenu {
  menuList?: IHeaderProfileMenuItem[];
  isLoading: boolean;
}

const iconMapping = {
  settings: <SettingsRounded fontSize="small" />,
  help: <HelpOutline fontSize="small" />,
  admin_filtering: <TuneRounded fontSize="small" />,
  admin_reports: <SummarizeRounded fontSize="small" />,
  logout: <LogoutRounded fontSize="small" />,
};

const ProfileMenu: FC<IProfileMenu> = ({ menuList = [], isLoading }) => {
  const handleDelete = async (url: string) => {
    await fetch(url, { method: 'DELETE' });
    window.location.reload();
  };

  const getMenuItem = (menuItem: IHeaderProfileMenuItem) => {
    const icon = iconMapping[menuItem.icon];

    if (menuItem.method === 'delete') {
      return (
        <>
          <ListItemIcon>{icon}</ListItemIcon>
          <Button
            variant="text"
            sx={styles.button}
            onClick={() => {
              handleDelete(menuItem.link).catch(console.error);
            }}
          >
            <ListItemText sx={styles.optionLink}>{menuItem.name}</ListItemText>
          </Button>
        </>
      );
    }

    return (
      <>
        <ListItemIcon>{icon}</ListItemIcon>
        <Link href={menuItem.link} sx={styles.optionLink}>
          <ListItemText sx={styles.optionLink}>{menuItem.name}</ListItemText>
        </Link>
      </>
    );
  };

  if (isLoading) return <CircularProgress size={20} />;

  return (
    <Paper sx={styles.profileMenu}>
      <MenuList>
        {menuList.map(menuItem => (
          <MenuItem key={menuItem.id} sx={styles.option}>
            {getMenuItem(menuItem)}
          </MenuItem>
        ))}
      </MenuList>
    </Paper>
  );
};

export default ProfileMenu;
